import React, { Fragment } from 'react'
import TopBanner from '../../Components/Main/TopBanner'
import CartDetail from '../../Components/Cart/CartDetail'

const Cart = () => {
    return (
        <Fragment>
            <TopBanner title={"My Cart"} />
            <CartDetail />
        </Fragment>
    )
}

export default Cart